import NodeSystemOut from './node-system-out';

export default NodeSystemOut;
